// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__6GuEn","errorImg":"NotFound_errorImg__I6iZ1","heading":"NotFound_heading__9QDl5","toMainPage":"NotFound_toMainPage__PyWnb"};